import { Spacing } from '@billy/design-system'
import { css } from '@emotion/core'

export const getCellStyles = () => {
  return css`
    padding: ${Spacing.S12} ${Spacing.S16};
    text-align: right;
    &:first-child {
      text-align: left;
    }
  `
}
